/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetMember,
  FleetMembersList,
  FleetSquadron,
  FleetSquadronCreateInput,
  FleetSquadronMemberCreateInput,
  FleetSquadronMemberUpdateInput,
  FleetSquadronMembersParams,
  FleetSquadronMoveInput,
  FleetSquadronUpdateInput,
  FleetSquadronsList,
  FleetSquadronsParams,
  PublicFleetSquadron,
  PublicFleetSquadronsList,
  PublicFleetSquadronsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Fleet Squadron
 */
export const createFleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronCreateInput: MaybeRefOrGetter<FleetSquadronCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetSquadronCreateInput = toValue(fleetSquadronCreateInput);

      return axiosClient<FleetSquadron>(
      {url: `/fleets/${fleetSlug}/squadrons`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetSquadronCreateInput, signal
    },
      );
    }




export const getCreateFleetSquadronMutationKey = () => ['createFleetSquadron'] as const;

export const getCreateFleetSquadronMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadron>>, TError,CreateFleetSquadronMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadron>>, TError,CreateFleetSquadronMutationVariables, TContext> => {

const mutationKey = getCreateFleetSquadronMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetSquadron>>, CreateFleetSquadronMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetSquadron(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetSquadronMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetSquadron>>>
    export type CreateFleetSquadronMutationBody = FleetSquadronCreateInput
    export type CreateFleetSquadronMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetSquadronMutationVariables = {fleetSlug: string;data: FleetSquadronCreateInput}

    /**
 * @summary Create Fleet Squadron
 */
export const useCreateFleetSquadron = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadron>>, TError,CreateFleetSquadronMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetSquadron>>,
        TError,
        CreateFleetSquadronMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetSquadronMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Squadrons List
 */
export const fleetSquadrons = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetSquadronsList>(
      {url: `/fleets/${fleetSlug}/squadrons`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetSquadronsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronsParams>,) => {
    return [
    'fleets',fleetSlug,'squadrons', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetSquadronsQueryOptions = <TData = Awaited<ReturnType<typeof fleetSquadrons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadrons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetSquadronsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetSquadrons>>> = ({ signal }) => fleetSquadrons(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetSquadrons>>, TError, TData>
}

export type FleetSquadronsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetSquadrons>>>
export type FleetSquadronsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Squadrons List
 */

export function useFleetSquadrons<TData = Awaited<ReturnType<typeof fleetSquadrons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadrons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetSquadronsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Add Fleet Squadron Member
 */
export const createFleetSquadronMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    fleetSquadronMemberCreateInput: MaybeRefOrGetter<FleetSquadronMemberCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetSquadronSlug = toValue(fleetSquadronSlug);
fleetSquadronMemberCreateInput = toValue(fleetSquadronMemberCreateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/squadrons/${fleetSquadronSlug}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetSquadronMemberCreateInput, signal
    },
      );
    }




export const getCreateFleetSquadronMemberMutationKey = () => ['createFleetSquadronMember'] as const;

export const getCreateFleetSquadronMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadronMember>>, TError,CreateFleetSquadronMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadronMember>>, TError,CreateFleetSquadronMemberMutationVariables, TContext> => {

const mutationKey = getCreateFleetSquadronMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetSquadronMember>>, CreateFleetSquadronMemberMutationVariables> = (props) => {
          const {fleetSlug,fleetSquadronSlug,data} = props ?? {};

          return  createFleetSquadronMember(fleetSlug,fleetSquadronSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetSquadronMemberMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetSquadronMember>>>
    export type CreateFleetSquadronMemberMutationBody = FleetSquadronMemberCreateInput
    export type CreateFleetSquadronMemberMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetSquadronMemberMutationVariables = {fleetSlug: string;fleetSquadronSlug: string;data: FleetSquadronMemberCreateInput}

    /**
 * @summary Add Fleet Squadron Member
 */
export const useCreateFleetSquadronMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetSquadronMember>>, TError,CreateFleetSquadronMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetSquadronMember>>,
        TError,
        CreateFleetSquadronMemberMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetSquadronMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Squadron Members List
 */
export const fleetSquadronMembers = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronMembersParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetSquadronSlug = toValue(fleetSquadronSlug);
params = toValue(params);

      return axiosClient<FleetMembersList>(
      {url: `/fleets/${fleetSlug}/squadrons/${fleetSquadronSlug}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetSquadronMembersQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronMembersParams>,) => {
    return [
    'fleets',fleetSlug,'squadrons',fleetSquadronSlug,'members', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetSquadronMembersQueryOptions = <TData = Awaited<ReturnType<typeof fleetSquadronMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadronMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetSquadronMembersQueryKey(fleetSlug,fleetSquadronSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetSquadronMembers>>> = ({ signal }) => fleetSquadronMembers(fleetSlug,fleetSquadronSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(fleetSquadronSlug) !== null && toValue(fleetSquadronSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetSquadronMembers>>, TError, TData>
}

export type FleetSquadronMembersQueryResult = NonNullable<Awaited<ReturnType<typeof fleetSquadronMembers>>>
export type FleetSquadronMembersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Squadron Members List
 */

export function useFleetSquadronMembers<TData = Awaited<ReturnType<typeof fleetSquadronMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetSquadronMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadronMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetSquadronMembersQueryOptions(fleetSlug,fleetSquadronSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove Fleet Squadron Member
 */
export const destroyFleetSquadronMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetSquadronSlug = toValue(fleetSquadronSlug);
username = toValue(username);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/squadrons/${fleetSquadronSlug}/members/${username}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetSquadronMemberMutationKey = () => ['destroyFleetSquadronMember'] as const;

export const getDestroyFleetSquadronMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadronMember>>, TError,DestroyFleetSquadronMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadronMember>>, TError,DestroyFleetSquadronMemberMutationVariables, TContext> => {

const mutationKey = getDestroyFleetSquadronMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetSquadronMember>>, DestroyFleetSquadronMemberMutationVariables> = (props) => {
          const {fleetSlug,fleetSquadronSlug,username} = props ?? {};

          return  destroyFleetSquadronMember(fleetSlug,fleetSquadronSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetSquadronMemberMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetSquadronMember>>>

    export type DestroyFleetSquadronMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetSquadronMemberMutationVariables = {fleetSlug: string;fleetSquadronSlug: string;username: string}

    /**
 * @summary Remove Fleet Squadron Member
 */
export const useDestroyFleetSquadronMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadronMember>>, TError,DestroyFleetSquadronMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetSquadronMember>>,
        TError,
        DestroyFleetSquadronMemberMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetSquadronMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Fleet Squadron Member
 */
export const updateFleetSquadronMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetSquadronSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
    fleetSquadronMemberUpdateInput: MaybeRefOrGetter<FleetSquadronMemberUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetSquadronSlug = toValue(fleetSquadronSlug);
username = toValue(username);
fleetSquadronMemberUpdateInput = toValue(fleetSquadronMemberUpdateInput);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/squadrons/${fleetSquadronSlug}/members/${username}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetSquadronMemberUpdateInput, signal
    },
      );
    }




export const getUpdateFleetSquadronMemberMutationKey = () => ['updateFleetSquadronMember'] as const;

export const getUpdateFleetSquadronMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadronMember>>, TError,UpdateFleetSquadronMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadronMember>>, TError,UpdateFleetSquadronMemberMutationVariables, TContext> => {

const mutationKey = getUpdateFleetSquadronMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetSquadronMember>>, UpdateFleetSquadronMemberMutationVariables> = (props) => {
          const {fleetSlug,fleetSquadronSlug,username,data} = props ?? {};

          return  updateFleetSquadronMember(fleetSlug,fleetSquadronSlug,username,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetSquadronMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetSquadronMember>>>
    export type UpdateFleetSquadronMemberMutationBody = FleetSquadronMemberUpdateInput
    export type UpdateFleetSquadronMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetSquadronMemberMutationVariables = {fleetSlug: string;fleetSquadronSlug: string;username: string;data: FleetSquadronMemberUpdateInput}

    /**
 * @summary Update Fleet Squadron Member
 */
export const useUpdateFleetSquadronMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadronMember>>, TError,UpdateFleetSquadronMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetSquadronMember>>,
        TError,
        UpdateFleetSquadronMemberMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetSquadronMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete Fleet Squadron
 */
export const destroyFleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/squadrons/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetSquadronMutationKey = () => ['destroyFleetSquadron'] as const;

export const getDestroyFleetSquadronMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadron>>, TError,DestroyFleetSquadronMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadron>>, TError,DestroyFleetSquadronMutationVariables, TContext> => {

const mutationKey = getDestroyFleetSquadronMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetSquadron>>, DestroyFleetSquadronMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetSquadron(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetSquadronMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetSquadron>>>

    export type DestroyFleetSquadronMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetSquadronMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Delete Fleet Squadron
 */
export const useDestroyFleetSquadron = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetSquadron>>, TError,DestroyFleetSquadronMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetSquadron>>,
        TError,
        DestroyFleetSquadronMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetSquadronMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Squadron
 */
export const fleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetSquadron>(
      {url: `/fleets/${fleetSlug}/squadrons/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetSquadronQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'squadrons',slug
    ] as const;
    }


export const getFleetSquadronQueryOptions = <TData = Awaited<ReturnType<typeof fleetSquadron>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadron>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetSquadronQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetSquadron>>> = ({ signal }) => fleetSquadron(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetSquadron>>, TError, TData>
}

export type FleetSquadronQueryResult = NonNullable<Awaited<ReturnType<typeof fleetSquadron>>>
export type FleetSquadronQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Squadron
 */

export function useFleetSquadron<TData = Awaited<ReturnType<typeof fleetSquadron>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetSquadron>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetSquadronQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Squadron
 */
export const updateFleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetSquadronUpdateInput: MaybeRefOrGetter<FleetSquadronUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetSquadronUpdateInput = toValue(fleetSquadronUpdateInput);

      return axiosClient<FleetSquadron>(
      {url: `/fleets/${fleetSlug}/squadrons/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetSquadronUpdateInput, signal
    },
      );
    }




export const getUpdateFleetSquadronMutationKey = () => ['updateFleetSquadron'] as const;

export const getUpdateFleetSquadronMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadron>>, TError,UpdateFleetSquadronMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadron>>, TError,UpdateFleetSquadronMutationVariables, TContext> => {

const mutationKey = getUpdateFleetSquadronMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetSquadron>>, UpdateFleetSquadronMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetSquadron(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetSquadronMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetSquadron>>>
    export type UpdateFleetSquadronMutationBody = FleetSquadronUpdateInput
    export type UpdateFleetSquadronMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetSquadronMutationVariables = {fleetSlug: string;slug: string;data: FleetSquadronUpdateInput}

    /**
 * @summary Update Fleet Squadron
 */
export const useUpdateFleetSquadron = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetSquadron>>, TError,UpdateFleetSquadronMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetSquadron>>,
        TError,
        UpdateFleetSquadronMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetSquadronMutationOptions(options), queryClient);
    }
    /**
 * @summary Move Fleet Squadron
 */
export const moveFleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetSquadronMoveInput: MaybeRefOrGetter<FleetSquadronMoveInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetSquadronMoveInput = toValue(fleetSquadronMoveInput);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/squadrons/${slug}/move`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetSquadronMoveInput, signal
    },
      );
    }




export const getMoveFleetSquadronMutationKey = () => ['moveFleetSquadron'] as const;

export const getMoveFleetSquadronMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFleetSquadron>>, TError,MoveFleetSquadronMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveFleetSquadron>>, TError,MoveFleetSquadronMutationVariables, TContext> => {

const mutationKey = getMoveFleetSquadronMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveFleetSquadron>>, MoveFleetSquadronMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  moveFleetSquadron(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveFleetSquadronMutationResult = NonNullable<Awaited<ReturnType<typeof moveFleetSquadron>>>
    export type MoveFleetSquadronMutationBody = FleetSquadronMoveInput
    export type MoveFleetSquadronMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type MoveFleetSquadronMutationVariables = {fleetSlug: string;slug: string;data: FleetSquadronMoveInput}

    /**
 * @summary Move Fleet Squadron
 */
export const useMoveFleetSquadron = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveFleetSquadron>>, TError,MoveFleetSquadronMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveFleetSquadron>>,
        TError,
        MoveFleetSquadronMutationVariables,
        TContext
      > => {
      return useMutation(getMoveFleetSquadronMutationOptions(options), queryClient);
    }
    /**
 * @summary Public Fleet Squadrons List
 */
export const publicFleetSquadrons = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetSquadronsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<PublicFleetSquadronsList>(
      {url: `/public/fleets/${fleetSlug}/squadrons`, method: 'GET',
        params, signal
    },
      );
    }




export const getPublicFleetSquadronsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetSquadronsParams>,) => {
    return [
    'public','fleets',fleetSlug,'squadrons', ...(params ? [params] : [])
    ] as const;
    }


export const getPublicFleetSquadronsQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetSquadrons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetSquadronsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadrons>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetSquadronsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetSquadrons>>> = ({ signal }) => publicFleetSquadrons(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadrons>>, TError, TData>
}

export type PublicFleetSquadronsQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetSquadrons>>>
export type PublicFleetSquadronsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Squadrons List
 */

export function usePublicFleetSquadrons<TData = Awaited<ReturnType<typeof publicFleetSquadrons>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<PublicFleetSquadronsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadrons>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetSquadronsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Public Fleet Squadron
 */
export const publicFleetSquadron = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<PublicFleetSquadron>(
      {url: `/public/fleets/${fleetSlug}/squadrons/${slug}`, method: 'GET', signal
    },
      );
    }




export const getPublicFleetSquadronQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'public','fleets',fleetSlug,'squadrons',slug
    ] as const;
    }


export const getPublicFleetSquadronQueryOptions = <TData = Awaited<ReturnType<typeof publicFleetSquadron>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadron>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPublicFleetSquadronQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof publicFleetSquadron>>> = ({ signal }) => publicFleetSquadron(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadron>>, TError, TData>
}

export type PublicFleetSquadronQueryResult = NonNullable<Awaited<ReturnType<typeof publicFleetSquadron>>>
export type PublicFleetSquadronQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Public Fleet Squadron
 */

export function usePublicFleetSquadron<TData = Awaited<ReturnType<typeof publicFleetSquadron>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof publicFleetSquadron>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPublicFleetSquadronQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






